/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InventoryData {
    getFixupPrototypeFunction() { return InventoryData.fixupPrototype; }

    static newInstance(model: Partial<InventoryData>): InventoryData {
        let obj = Object.assign(new InventoryData(), model);
        InventoryData.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InventoryData>): InventoryData {
        if (!model) return null;
        return InventoryData.newInstance(<InventoryData> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InventoryData) {
        if (!obj) return;

        models.InventoryData.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InventoryData): boolean {
        Object.setPrototypeOf(obj, InventoryData.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Filters available in inventory
     */
    data: Array<any>;

    /**
     * Type of the data available in models list
     */
    type: string;

}
